import React from 'react'
import CreateProjectStep1 from './createproject-step1.components'
import { Steps } from 'antd'

const { Step } = Steps
const CreateProjectContainer = () => {
  return <CreateProjectStep1 />
}

export default CreateProjectContainer
